import { Chapter, CycleEL, UserEL } from "../elearning";
import { QueovalBase } from "../global";

export class AffecteCycleELModel extends QueovalBase {
  public ListUsers: Array<UserEL>;
  public UserSelected: UserEL;
  public ListAllCycles: Array<CycleEL>;

  // Division des chapitres en 3 listes distinctes
  /**
   * Liste des chapitres E-Learning (non auteur)
   */
  public ListChaptersEL: Array<Chapter>;
  /**
   * Liste des chapitres auteurs achétés
   */
  public ListChaptersAutOk: Array<Chapter>;
  /**
   * Liste des chapitres disponibles
   */
  public ListChaptersAutAvailable: Array<Chapter>;

  public ChapterSelected: Chapter;

  public StripeIsActif: boolean;
}
